<template>
  <span>
    <input class="e-address"
         :type="inputType"
         :class="hasError ? 'is-invalid' : ''"
         :style="inputStyle"
         :name="name"
         ref="input"
         @blur="onBlur"
         @change="change"
         @input="onInput"
         v-on:keyup.enter.prevent="onEnter"
         :placeholder="getPlaceholder"
         v-bind:disabled="disabled"
         v-bind:data-validate-alias="validateAlias"
         v-model="model[name]" />
    <span class="actions-panel">
      <slot name="buttons_panel"></slot>
    </span>
  </span>
  
</template>

<script>
  /* global $ */
  // import suggestions from 'suggestions-jquery/src/main'
  import suggestions from 'suggestions-jquery'
  import {DADATA_TOKEN, DADATA_REGION, DADATA_COUNTRY} from '../../config/config.js'
  import {AddressModel} from "./AddressModel";

  // data-* attributes used for debug
  export default {
    name: 'address-dadata',
    data () {
      return {
        error: null
      }
    },
    props: {
      inputStyle: {
        type: Object,
        default: () => {}
      },
      onChangeValidation: {
        type: Boolean,
        default: false
      },
      formValidator: null,
      model: {
        type: Object,
        required: true
      },
      tabView: {
        type: String,
        default: null
      },
      name: {
        type: String,
        default: null,
        required: true
      },
      validateAlias: {
        type: String,
        default: null
      },
      required: {
        type: Boolean,
        default: false
      },
      modalVariableName: {
        type: String,
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: null
      },
      inputType: {
        type: String,
        default: 'text'
      },
      mask: {
        type: String,
        default: null
      },
      onValidate: {
        type: Function,
        default: (obj) => obj
      },
      addressData: {
        type: Object,
        required: true,
        default: function () {
          return {}
        }
      },
      addressIdFieldName: {
        type: String,
        default: 'address_id'
      },
      houseFiasFieldName: {
        type: String,
        default: null
      },
      geoFields: {
        type: Array
      },
      callbacks: {
        type: Object,
        default: () => ({
          onSuggestionsFetch: (suggestions) => suggestions,
          // eslint-disable-next-line
          onSuggestMount: (suggestInst) => void null
        })
      }
    },
    computed: {
      getPlaceholder () {
        if (this.placeholder === null) {
          return ''
        }
        return this.placeholder
      },
      hasError () {
        if (this.error) {
          return true
        }
        return false
      }
    },
    created () {
      if (this.formValidator) {
        this.formValidator.subscribeInput(this)
      }
    },
    destroyed () {
      if (this.formValidator) {
        this.formValidator.unsubscribeInput(this)
      }
    },
    mounted () {
      // docs: https://confluence.hflabs.ru/pages/viewpage.action?pageId=204669097
      // rest api docs: https://confluence.hflabs.ru/pages/viewpage.action?pageId=204669107
      const options = {
        token: DADATA_TOKEN,
        type: 'ADDRESS',
        constraints: {
          locations: {
            region_fias_id: DADATA_REGION,
            country: DADATA_COUNTRY
          }
        },
        restrict_value: true,
        // TODO: бывает restrict не работает
        // TODO: проблема с фокусом по тому же адресу и выбору его же(не происходит изменения)
        noCache: true,
        onSelect: this.onSelect
      }
      // see https://github.com/hflabs/suggestions-jquery/blob/master/src/includes/types/address.js#L212
      // for suggestion data format help in onSuggestionsFetch
      if (this.callbacks.onSuggestionsFetch) {
        options.onSuggestionsFetch = this.callbacks.onSuggestionsFetch
      }

      this.suggestions = $(this.$refs.input).suggestions(options).suggestions()

      this.callbacks.onSuggestMount && this.callbacks.onSuggestMount(this.suggestions)
    },
    methods: {
      onSelect (raw) {
        console.log(raw)
        const data = new AddressModel()
        data.value = raw.value
        data.raw = raw
        data.data.setDadata(raw)
        data.addressIdFieldName = this.addressIdFieldName
        data.houseFiasFieldName = this.houseFiasFieldName
        data.fiasFieldName = this.fiasFieldName
        this.addressData[this.name] = data
        this.model[this.name] = data.value

        if (this.houseFiasFieldName) {
          this.model[this.houseFiasFieldName] = data.data.house_fias_id
        }

        if (this.fiasFieldName) {
          this.model[this.fiasFieldName] = data.data.fias_id
        }

        console.log(data)

        if (this.geoFields) {
          this.model[this.geoFields[0]] = data.data.geo_lat
          this.model[this.geoFields[1]] = data.data.geo_lon
        }

        this.$emit('selectItem', data)
      },
      onEnter ($event) {
        this.$emit('enter', $event)
      },
      onBlur ($event) {
        this.$emit('blur', $event)
      },
      onInput (e) {
        this.$emit('input', e)
      },
      change ($event) {
        this.$emit('change', $event)
      },
      getElement () {
        return this.$refs.input
      },
      validate () {
        let msg = ''
        if (this.required && !this.model[this.name]) {
          msg += 'Укажите адрес'
        }

        if (this.required && this.fiasFieldName && !this.model[this.fiasFieldName]) {
          msg = 'Начните вводить и выберите адрес из списка'
        }

        if (this.required && this.houseFiasFieldName && !this.model[this.houseFiasFieldName]) {
          msg = 'Укажите адрес, включающий номер дома'
        }

        return this.onValidate({
          error: msg,
          tabView: this.tabView,
          name: this.name,
          modalVariableName: this.modalVariableName,
          el: this.getElement(),
          model: this.model
        })
      }
    }
  }
</script>
<style lang="scss">
  .actions-panel {
    vertical-align: middle;
  }
</style>